import { get, isEmpty, isNil, uniqueId } from 'lodash';
import { useState } from 'react';
import {
  Grid,
  Card,
  Chip,
  MenuItem,
  Popper,
  MenuList,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MoreIcon from 'images/more-icon.svg';

import {
  StyledCard,
  StyledTitle,
  ChipBody,
  StyledPopper,
  StyledMenuItem,
  ChipDecision,
} from 'containers/CourtManagerLegalProceedings/ImagineDocuments/style';
import { getLiveDocumentViewUrl } from 'containers/UploadDocuments/utils';

export interface DocumentCardProps {
  document: any;
  toTreat: boolean;
  decisionItems: [];
  decisionOption: any;
  setDecisionOption: Function;
  notificationDocument: any;
  isConsultation: boolean;
  setDocument?: Function;
  selecteDocument?: any;
  isImportDocument?: boolean;
  requestGetDocByDocumentumId: Function;
}

const DocumentCard = (props: DocumentCardProps) => {
  const [openReason, setOpenReason] = useState(false);

  const handleOpenReason = () => {
    setOpenReason(!openReason);
  };

  const handleChangeDocument = (documentId: any) => (e: any) => {
    const { checked } = e.target;
    if (checked && props.setDocument) {
      props.setDocument(documentId);
    }
  };

  return (
    <Card style={StyledCard} elevation={0}>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
      >
        {props.isImportDocument && (
          <Grid item xs={1}>
            <FormGroup key={uniqueId()}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      props.selecteDocument === props.document?.DocumentID
                    }
                    color="primary"
                    value={props.selecteDocument}
                    onChange={handleChangeDocument(props.document?.DocumentID)}
                    style={{ marginTop: '-3px', padding: 3 }}
                  />
                }
                label={''}
              />
            </FormGroup>
          </Grid>
        )}
        <Grid item>
          <Grid container direction="column" spacing={1}>
            <Grid item style={StyledTitle}>
              {get(props.document, 'DocumentType')}
            </Grid>
            {props.toTreat && (
              <Grid item>
                <Chip style={ChipBody} label={'Imaging'} />
                {(!isNil(
                  get(
                    props.notificationDocument,
                    'documentImaging.documentImagingDecisionId',
                    null,
                  ),
                ) ||
                  isNil(
                    get(props.notificationDocument, 'treatedBy', null),
                  )) && (
                  <Chip
                    style={ChipDecision}
                    label={get(
                      props.decisionItems?.find(
                        (el: any) =>
                          el.id ===
                          get(
                            props.notificationDocument,
                            'documentImaging.documentImagingDecisionId',
                            null,
                          ),
                      ),
                      'title',
                    )}
                  />
                )}
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item>
              <VisibilityIcon
                onClick={() => {
                  props.requestGetDocByDocumentumId(
                    getLiveDocumentViewUrl(
                      props.document.path,
                      props.document.fileName,
                      props.document.isIndexed,
                      props.document.DocumentID,
                    ),
                  );
                }}
                style={{ color: 'black' }}
                className="consult"
              />
            </Grid>
            {props.toTreat &&
              !props.isConsultation &&
              isNil(
                get(
                  props.notificationDocument,
                  'documentImaging.documentImagingDecisionId',
                  null,
                ),
              ) &&
              isNil(get(props.notificationDocument, 'treatedBy', null)) && (
                <Grid item style={{ cursor: 'pointer' }}>
                  <img src={MoreIcon} onClick={handleOpenReason} alt="more" />
                  {openReason && !isEmpty(props.decisionItems) && (
                    <Popper
                      open={Boolean(openReason)}
                      placement="bottom"
                      transition
                      disablePortal
                      style={{ ...StyledPopper }}
                    >
                      <MenuList
                        style={{
                          padding: 0,
                        }}
                      >
                        {props.decisionItems.map((el: any) => (
                          <MenuItem
                            key={uniqueId('menu-item')}
                            style={StyledMenuItem}
                            onClick={() => props.setDecisionOption(el)}
                          >
                            {get(el, 'title', '')}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </Popper>
                  )}
                </Grid>
              )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default DocumentCard;
